module.exports = __webpack_public_path__ + "static/media/blog.6ca1ce82.png";